import { defineComponent as _defineComponent } from 'vue'
import AddToBasketCtaBlockViewModel = Vertica.LouisPoulsen.Application.Content.Blocks.AddToBasketCtaBlockViewModel;
import { computed } from 'vue';
import { store } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockAddToBasketCTA',
  props: {
    model: null
  },
  setup(__props: any) {

const props = __props as {
    model: AddToBasketCtaBlockViewModel
}



const isBasketLocked = computed<boolean>(() => store.getters['basket/isBasketLocked']);
const variantBeingAdded = computed<string | null>(() => store.getters['basket/variantBeingAdded']);

const showSpinner = computed<boolean>(() => {
    if (variantBeingAdded.value === null) { return false; }
    return props.model.variantCode === variantBeingAdded.value;
});

function addToBasket(payload: AddToBasketWebRequest) {
    store.dispatch('basket/addToBasket', payload);
}

async function onAdd() {
    addToBasket({
        id: props.model.variantCode,
        quantity: 1,
        reference: null,
        basketType: null,
        cordLength: null,
        serviceProductId: null,
        discountPercent: null
    });
}

return { __sfc: true,props, isBasketLocked, variantBeingAdded, showSpinner, addToBasket, onAdd }
}

})